import React from 'react';
import type { Plant } from '../../../../types/plant';
import { Package, BookOpen } from 'lucide-react';

interface StorageProps {
  plant: Plant;
}

export default function Storage({ plant }: StorageProps) {
  return (
    <section className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-2xl font-semibold mb-6">Storage & Preservation</h2>
      <div className="space-y-6">
        {/* Storage Duration */}
        <div className="border-b pb-6">
          <div className="flex items-center gap-2 mb-3">
            <Package className="h-5 w-5 text-primary-500" />
            <h3 className="text-lg font-medium">Storage Duration</h3>
          </div>
          <p className="text-gray-600">{plant.storage_duration}</p>
        </div>

        {/* Preservation Methods */}
        <div className="pb-6">
          <div className="flex items-center gap-2 mb-3">
            <BookOpen className="h-5 w-5 text-primary-500" />
            <h3 className="text-lg font-medium">Preservation Methods</h3>
          </div>
          <p className="text-gray-600">{plant.preservation_methods}</p>
        </div>
      </div>
    </section>
  );
}